class ct_chart_popup extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (e) => {
      const wrapper = this.querySelector(".ct-slac-chart-popup-wrapper");
      if(!wrapper.contains(e.target)) {
        this.close();
      }
    });
    this.querySelector(".ct-slac-chart-popup-header svg").addEventListener("click", () => {
      this.close();
    });
  }
  connectedCallback() {
    document.querySelector(".ct-slac-chart").addEventListener("click", () => {
      console.log("hiereeer");
      this.open();
    });
  }
  close() {
    this.removeAttribute("opened");
  }
  open() {
    this.setAttribute("opened", "");
  }
}
customElements.define("ct-chart-popup", ct_chart_popup);